import { createSlice } from '@reduxjs/toolkit';

export const initSlice = createSlice({
  name: 'init',
  initialState: {
    connectionArgs: {},
    loadedTranslations: false,
  },
  reducers: {
    setLoadedTranslations: (state, action) => {
      state.loadedTranslations = action.payload;
    },
  }
});

export const getConnectionArgs = (state) => state.init.connectionArgs;

export const getConnectionArg = (state, prop) => state.init.connectionArgs[prop] ?? null;

export const getInited = (state) => state.init.loadedTranslations;

export const getIsAndroidApp = (state) => {
  const app = state.init.connectionArgs['app'] ?? null;
  return app === 'android' || app === '1';
}

export default initSlice.reducer;
